<template>
  <vs-table hover-flat v-if="transferLogs && transferLogs.length" :data="transferLogs">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('username')"></vs-th>
      <vs-th v-text="$t('representative_number')"></vs-th>
      <vs-th v-text="$t('called_number')"></vs-th>
      <vs-th class="text-center" v-text="$t('status')"></vs-th>
      <vs-th v-text="$t('modified_date')"></vs-th>
      <vs-th v-text="$t('result')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.transferred_by" :data-tr-title="$t('username')"></vs-td>
        <vs-td v-text="tr.title" :data-tr-title="$t('representative_number')"></vs-td>
        <vs-td v-text="tr.channel" :data-tr-title="$t('called_number')"></vs-td>
        <vs-td class="text-center">
          <badge-transfer :status="tr.status"></badge-transfer>
        </vs-td>
        <vs-td :data-tr-title="$t('modified_date')">{{ tr.created_at | readableDate }}</vs-td>
        <vs-td v-text="tr.result" :data-tr-title="$t('result')"></vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>

import BadgeTransfer from '@/components/badge/Transfer'
export default {
  name: 'Shared.Transfers.History',
  components: {
    BadgeTransfer
  },
  props: {
    transferLogs: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
